/**
 * `useCurrentPath` returns the matched absolute route path string for the
 * current location.
 *
 * It matches the current URL against a known list of app routes and returns
 * the matched `route.path`, or an empty string when no single match exists.
 */
import { matchRoutes, useLocation } from 'react-router-dom';
import { PageAbsolutePath } from '../../consts/Common';

export const useCurrentPath = (): string => {
  const routes = [
    { path: PageAbsolutePath.Renewals.Landing },
    { path: PageAbsolutePath.Renewals.PersonalDetails },
    { path: PageAbsolutePath.Renewals.VehicleDetails },
    { path: PageAbsolutePath.Renewals.Quote },
    { path: PageAbsolutePath.Renewals.Summary },
    { path: PageAbsolutePath.Renewals.DirectDebit },
    { path: PageAbsolutePath.Renewals.SinglePayment },
    { path: PageAbsolutePath.Renewals.Confirmation },
    { path: PageAbsolutePath.Renewals.FailedRegistration },
    { path: PageAbsolutePath.Renewals.LateRenewalAcceptance },
    { path: PageAbsolutePath.Customer.Landing },
    { path: PageAbsolutePath.Customer.VehicleDetails },
    { path: PageAbsolutePath.Customer.Products },
    { path: PageAbsolutePath.Customer.CreatePlan },
    { path: PageAbsolutePath.Customer.PersonalDetails },
    { path: PageAbsolutePath.Customer.Summary },
    { path: PageAbsolutePath.Customer.DirectDebit },
    { path: PageAbsolutePath.Customer.SinglePayment },
    { path: PageAbsolutePath.Customer.Confirmation },
    { path: PageAbsolutePath.Customer.FailedRegistration },
    { path: PageAbsolutePath.Customer.PaymentAssistSuccess },
    { path: PageAbsolutePath.Customer.PaymentAssistFailure },
    { path: PageAbsolutePath.Landing },
    { path: PageAbsolutePath.VehicleDetails },
    { path: PageAbsolutePath.Products },
    { path: PageAbsolutePath.CreatePlan },
    { path: PageAbsolutePath.PersonalDetails },
    { path: PageAbsolutePath.Summary },
    { path: PageAbsolutePath.DirectDebit },
    { path: PageAbsolutePath.SinglePayment },
    { path: PageAbsolutePath.Confirmation },
    { path: PageAbsolutePath.FailedRegistration },
    { path: PageAbsolutePath.UnderMaintenance },
    { path: PageAbsolutePath.PaymentAssistSuccess },
    { path: PageAbsolutePath.PaymentAssistFailure },
    { path: PageAbsolutePath.Error },
    { path: PageAbsolutePath.Suppression }
  ];

  const location = useLocation();
  const matchedRoutes = matchRoutes(routes, location);

  if (matchedRoutes?.length === 1) {
    return matchedRoutes[0].route?.path || '';
  }

  return '';
};
